var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-footer',{attrs:{"app":"","fixed":"","tile":"","dense":"","inset":""}},[_c('span',{staticClass:"caption pt-0"},[_vm._v("\n      Rows: "+_vm._s(_vm.items)+"\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }